// src/services/api.js
import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_PATH}`;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const dashboardService = {
  getSummary: () => api.get('accdash/summary'),
  getMonthlySummary: (months = 6) => api.get(`accdash/monthly-summary?months=${months}`),
  getTopAccounts: (top = 10) => api.get(`accdash/top-accounts?top=${top}`),
  getRecentTransactions: (count = 10) => api.get(`accdash/recent-transactions?count=${count}`),
};

export const accountsService = {
  getAllAccounts: () => api.get('accounts'),
  getAllGroups: () => api.get('accounts/groups'),
};

export const transactionsService = {
  getTransactionById: (id) => api.get(`transactions/${id}`),
  createTransaction: (data) => api.post('transactions', data),
  updateTransaction: (id, data) => api.put(`transactions/${id}`, data),
  deleteTransaction: (id) => api.delete(`transactions/${id}`),
};

export default api;